import { useMemo as i } from "react";
import { getBreakpoint as o } from "./helpers/index.ts.js";
import { a as t } from "./use-window-size-CTHYqDff.js";
const l = (s) => {
  const [e] = t();
  return i(() => {
    const r = o(s ?? e);
    return {
      isXSmall: r === "xs",
      isSmall: r === "sm",
      isMedium: r === "md",
      isLarge: r === "lg",
      isXLarge: r === "xl",
      isXXLarge: r === "2xl"
    };
  }, [s, e]);
};
export {
  l as u
};
//# sourceMappingURL=use-breakpoints-Kqi6S3m8.js.map
